import rbsLogo from '../assets/rbs.svg';
import natwestLogo from '../assets/natwest.svg';

export type MortgageLinkType =
    | 'ListingsDetailsPage'
    | 'NewHomesListing'
    | 'ResidentialDetailsPage'
    | 'PropertyDetailsPage';

export type MortgageBankInfo = {
    link: string;
    logo: string;
    name: string;
    shortname: 'rbs' | 'natwest';
    altText: string;
};

export const getMortgageLinkType = (
    listingStatus: string,
    listingCondition: string
): MortgageLinkType => {
    if (listingStatus === 'for_sale' && listingCondition === 'new')
        return 'NewHomesListing';
    if (listingStatus === 'for_sale' && listingCondition === 'pre-owned')
        return 'ListingsDetailsPage';
    if (listingStatus === 'to_rent' && listingCondition === 'pre-owned')
        return 'ResidentialDetailsPage';
    if (listingStatus === 'for_sale' && listingCondition === 'pdp_details')
        return 'PropertyDetailsPage';

    return 'ListingsDetailsPage';
};

export const getMortgageCalculatorDetails = (
    region: string | null,
    listingStatus: string,
    listingCondition: string
): MortgageBankInfo => {
    const RBS_BANK = 'RBS';
    const NATWEST_BANK = 'NatWest';

    const RBS_INITIAL_URL = 'https://ad.doubleclick.net/ddm/clk/452012131;';
    const NATWEST_INITAL_URL = 'https://ad.doubleclick.net/ddm/clk/451889739;';

    const RBS_MORTGAGE_LINKS: Record<MortgageLinkType, string> = {
        ListingsDetailsPage:
            RBS_INITIAL_URL +
            '256022218;i?https://personal.rbs.co.uk/personal/mortgages/m/z/for-sale.html?RB-ZW-FS&extcam=R_PAR_ZOOP_Mtg_ZooplaForSale_Web_ALO_AL_OTH_&referrer=rbsprtnrZoopla',
        NewHomesListing:
            RBS_INITIAL_URL +
            '256021363;i?https://personal.rbs.co.uk/personal/mortgages/m/z/new-home.html?RB-ZW-NH&extcam=R_PAR_ZOOP_Mtg_ZooplaNewHome_Web_ALO_AL_OTH_&referrer=rbsprtnrZoopla',
        ResidentialDetailsPage:
            RBS_INITIAL_URL +
            '256021372;i?https://personal.rbs.co.uk/personal/mortgages/m/z/to-rent.html?RB-ZW-R&extcam=R_PAR_ZOOP_Mtg_ZooplaRent_Web_ALO_AL_OTH_&referrer=rbsprtnrZoopla',
        PropertyDetailsPage:
            RBS_INITIAL_URL +
            '256021375;l?https://personal.rbs.co.uk/personal/mortgages/m/z/property-details.html?RB-ZW-PD&extcam=R_PAR_ZOOP_Mtg_ZooplaProperty_Web_ALO_AL_OTH_&referrer=rbsprtnrZoopla'
    };

    const NATWEST_MORTGAGE_LINKS: Record<MortgageLinkType, string> = {
        ListingsDetailsPage:
            NATWEST_INITAL_URL +
            '255697949;t?https://personal.natwest.com/personal/mortgages/m/z/for-sale.html?NW-ZW-FS&extcam=N_PAR_ZOOP_Mtg_ZooplaForSale_Web_ALO_AL_OTH_&referrer=nwprtnrZoopla',
        NewHomesListing:
            NATWEST_INITAL_URL +
            '256161861;z?https://personal.natwest.com/personal/mortgages/m/z/new-home.html?NW-ZW-NH&extcam=N_PAR_ZOOP_Mtg_ZooplaNewHome_Web_ALO_AL_OTH_&referrer=nwprtnrZoopla',
        ResidentialDetailsPage:
            NATWEST_INITAL_URL +
            '256016899;j?https://personal.natwest.com/personal/mortgages/m/z/to-rent.html?NW-ZW-R&extcam=N_PAR_ZOOP_Mtg_ZooplaRent_Web_ALO_AL_OTH_&referrer=nwprtnrZoopla',
        PropertyDetailsPage:
            NATWEST_INITAL_URL +
            '255697916;n?https://personal.natwest.com/personal/mortgages/m/z/property-details.html?NW-ZW-PD&extcam=N_PAR_ZOOP_Mtg_ZooplaProperty_Web_ALO_AL_OTH_&referrer=nwprtnrZoopla'
    };

    const listingURL: MortgageLinkType = getMortgageLinkType(
        listingStatus,
        listingCondition
    );

    const RBSBank: MortgageBankInfo = {
        link: RBS_MORTGAGE_LINKS[listingURL],
        logo: rbsLogo,
        shortname: 'rbs',
        name: 'Royal Bank of Scotland',
        altText: 'In partnership with Royal Bank of Scotland'
    };

    const NatWestBank: MortgageBankInfo = {
        link: NATWEST_MORTGAGE_LINKS[listingURL],
        logo: natwestLogo,
        shortname: 'natwest',
        name: 'NatWest',
        altText: 'In partnership with NatWest'
    };

    const Banks = {
        NatWest: NatWestBank,
        RBS: RBSBank
    };

    return region === 'Scotland' ? Banks[RBS_BANK] : Banks[NATWEST_BANK];
};
